import React, { useEffect, useState } from 'react';

import Myexpense from '../../myExpense/Myexpense';
import ChartCom from '../chart/ChartCom';
import Form from '../expenseForm/Form';
import List from '../expenseForm/List';
import './Search.css'

const Search = () => {

     const [total, settotal] = useState(0)

    return (
        <div>
       
            <ChartCom total={total} />     
        </div>
    );
};

export default Search;